/**
 * Custom binding for jQuery File Upload
 * Usage:
 * <input data-bind="fileUpload: {url: 'https://localhost:8445/meeting/rest/2/settings/logo', done: doneFunction, fail:
 * failFunction, someOption: someVariable}" type="file" name="file" multiple>
 */

define('file-upload-binding',['require','file-upload','file-upload-iframe','knockout','lib/auth/auth'],function (require) {
    require('file-upload');
    require('file-upload-iframe');
    var ko = require('knockout');
    var auth = require('lib/auth/auth');

    /**
     * Normally you should never have to call getToken(),
     * but this binding is a special case because it makes an ajax call on your behalf.
     * so 'Authorization' header needs to be set through the plugin options
     */
    var userToken = 'Bearer ' + auth.getToken().access_token;
    ko.bindingHandlers.fileUpload = {
        init: function (element, valueAccessor) {
            var options = valueAccessor() || {};
            options.headers = {
                Authorization: userToken
            };
            options.url = options.url + '?_authorization=' + userToken;
            $(element).fileupload(options);
        }
    };
});

